import {
  BonusStrategy,
  BonusType,
  BonusResult,
  ConfettiConfig,
  AmountConstraints,
} from '../interfaces/bonus.interface';

export class Moneycon2026BonusStrategy implements BonusStrategy {
  type = BonusType.MONEYCON_2026;
  campaignSpecific = true;

  validateAmount(amount: number, minAmount: number = 10000000): boolean {
    return amount >= minAmount;
  }

  private isWithinActiveWindow(): boolean {
    const now = new Date();
    const startDate = new Date('2026-01-16T07:00:00-05:00');
    const endDate = new Date('2026-01-18T20:00:00-05:00');
    
    return now >= startDate && now <= endDate;
  }

  calculateBonus(amount: number, termDays: number): BonusResult {
    const terms = this.getTermsAndConditions();
    const minAmount = 10000000;
    const percentageDecimal = 0.005;

    if (!this.isWithinActiveWindow() || !this.validateAmount(amount, minAmount)) {
      return {
        isValid: false,
        bonusAmount: 0,
        message: '',
        confettiType: '',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }

    const bonusAmount = Math.round(amount * percentageDecimal * (termDays / 360));
    const displayAmount = this.formatCurrency(bonusAmount);
    const bonusMessage = `Puedes aplicar para un bono de <b class='text-green'>${displayAmount} </b>. Continua con <b>la apertura de tu CDT</b> para obtenerlo.`;

    return {
      isValid: true,
      minTermDays: [30, 60, 90, 180],
      label: '0.5%',
      value: '0.5%',
      bonusAmount,
      message: bonusMessage,
      messages: {
        desktop: 'Invierte desde $10.000.000 COP en Moneycon y MejorCDT te regala un bono extra del 0.5% E.A en tu monto para abrir tu CDT.',
        mobile: 'Invierte desde $10.000.000 COP en Moneycon y recibe un bono extra del 0.5% E.A una vez tu CDT esté activo',
      },
      message_simulador: bonusMessage,
      confettiType: 'default',
      displayAmount,
      bonusTag: 'porcentual',
      tagNameBonusType: 'MONEYCON_2026_PORCENTUAL_050',
      termsAndConditionsUrl: terms.url,
      termsAndConditionsDescription: terms.description,
    };
  }

  getTermsAndConditions(): { url: string; description: string } {
    return {
      url: 'legal/bono/moneycon-2026',
      description: 'El bono Moneycon 2026 es un cashback del 0.3% sobre el valor de tu inversión, válido únicamente del 17 al 18 de enero de 2026 y sujeto a un monto mínimo de $10.000.000 COP. No acumulable con otras promociones.'
    };
  }

  getConfettiConfig(): ConfettiConfig {
    return {
      type: 'default',
      duration: 4000,
      intensity: 'medium',
    };
  }

  getAmountConstraints(): AmountConstraints {
    return {
      locked: false,
      minAmount: 10000000,
    };
  }

  private formatCurrency(amount: number): string {
    return `$${amount.toLocaleString('es-CO')}`;
  }
}